import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import './css/fideliterClient.css';

const Fideliter = () => {
    let location = useLocation();
    return (
        <div>
            <Helmet>
                <title>Fidélité</title>
                <meta name='description' content='Fidélité' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='fideliter'>
                <div className='container'>
                    <div className='bloc_fideliter'>
                        <div className='titre'>
                            <h1><i className='fa fa-handshake-o'></i>Espace fidélité</h1>
                        </div>
                     
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Fideliter